<template>
  <div class="main-page">
    <div class="auth-content2">
      <h1 class="header-style">
        Change Passcode
      </h1>
      <br>
      <p class="subheader-style">
        Please enter your new passcode twice, so we can verify you typed it in correctly.
      </p>
      <br>
      <v-form
        ref="form"
        v-model="valid"
      >
        <p class="title-text-style">
          New Passcode
        </p>
        <div class="otp-style">
          <v-otp-input
            v-model="passcode"
            inputmode="numeric"
            type="number"
            :rules="[(v) => !!v || 'This field is required']"
            length="4"
            light
            color="#37474F"
          />
        </div>
        <p class="title-text-style">
          Confirm Passcode
        </p>
        <p
          v-if="isPasscodeMatch"
          class="passcode-mismatch"
        >
          {{ passwordConfirmationRule }}
        </p>
        <div class="otp-style">
          <v-otp-input
            v-model="confirmPasscode"
            type="number"
            inputmode="numeric"
            length="4"
            light
            :rules="confirmPasswordRules.concat(passwordConfirmationRule)"
            color="#37474F"
          />
        </div>
      </v-form>
      <v-btn
        class="mt-2 btn-style"
        color="#37474F"
        @click="resetPasscode()"
      >
        Reset
      </v-btn>
      <v-btn
        light
        color="#E6E6E6"
        class="mt-3 btn-style"
        elevation="0"
        @click="cancel()"
      >
        Cancel
      </v-btn>
      <centre-spinner :loading="loading" />
      <br>
      <br>
    </div>
  </div>
</template>
<script>
import Constants from 'src/constants';
import spinner from 'src/views/components/SpinnerCentre';
export default {
  name: 'CreateNewPasscode',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      loading: false,
      valid: false,
      cardBgImg: require('@/assets/img/cardBg.png'),
      verificationFailed: false,
      verificationFailedMessage: '',
      passcode: '',
      confirmPasscode: '',
      confirmPasswordRules: [v => !!v || 'This field is required'],
      mobileNumber: '',
    };
  },
  computed: {
    passwordConfirmationRule () {
      if (this.passcode === this.confirmPasscode) {
        return true;
      }
      return 'Passcode must match.';
    },
    isPasscodeMatch () {
      return this.confirmPasscode !== '' && this.passwordConfirmationRule !== true;
    },
    linkActiveId () {
      return this.$store.getters['passcodereset/getLinkActiveId'];
    },
    userId () {
      return this.$store.getters['passcodereset/getExternalId'];
    },
  },
  mounted () {
    // this.loadOnMount();
    this.getMobileNumber();
  },
  methods: {
    loadOnMount () {
      if (Object.keys(this.linkActiveId).length === 0) { this.$router.push({ name: 'GetStarted' }); }
    },
        getMobileNumber () {
      this.mobileNumber = this.$route.params.mobileNumber;
    },
    resetPasscode () {
      if (this.$refs.form.validate() === false || this.passwordConfirmationRule !== true) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.$store.dispatch('passcodereset/createNewPasscode', {
        phone_number: this.mobileNumber,
        password: this.passcode,
        password_confirmed: this.passwordConfirmationRule,
      }).then(response => {
        this.$store.dispatch('alert/onAlert', {
          message: 'Passcode updated successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.$store.dispatch('passcodereset/clearLinkActiveId');
        this.$router.push({ name: 'GetStarted' });
      }).catch(() => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
            message: 'Something went wrong in resetting the passcode',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
      });
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'GetStarted' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.subheader-style {
  color: #37474F;
}

.passcode-mismatch {
  font-size: 16px;
  font-weight: bold;
  color: #C62828;
  text-align: center;
}

.passcode-div {
  margin-bottom: 10px;
}

.title-text-style {
  text-align: center;
}
</style>
